import * as types from './mutation-types'

export const setBaseUrl = ({commit}, url) => {
    commit(types.BASE_URL, url)
};

export const signIn = ({commit}, user) => {
    commit(types.SIGN_IN, user)
};

export const signOut = ({commit}) => {
    commit(types.SIGN_OUT)
};

export const sessionExpired = ({commit}) => {
    commit(types.SESSION_EXPIRED)
};

export const updateUserInfo = ({commit}, user) => {
    commit(types.UPDATE_USER_INFO, user)
};

export const setTokenRefreshing = ({commit}, status) => {
    commit(types.TOKEN_REFRESHING, status)
};

export const updateCalcGaranties = ({commit}, quotes) => {
    commit(types.UPDATE_CALC_GARANTIES, quotes)
};

export const updateToken = ({commit}, moment) => {
    commit(types.TOKEN_UPDATED, moment)
};

export const backToDevisEnable = ({commit}) => {
    commit(types.BACK_TO_DEVIS_ENABLE)
};

export const backToDevisDisable = ({commit}) => {
    commit(types.BACK_TO_DEVIS_DISABLE)
};

export const updateDrivingSchoolInfo = ({commit}, payload) => {
    commit(types.UPDATE_DRIVING_SCHOOL_INFO, payload);
};

export const updateRepresentativeInfo = ({commit}, payload) => {
  commit(types.UPDATE_REPRESENTATIVE_INFO, payload);
};

export const updateRepresentativeVerificationDocuments = ({commit}, payload) => {
  commit(types.UPDATE_REPRESENTATIVE_VERIFICATION_DOCUMENTS, payload);
};



// WEBPACK FOOTER //
// ./src/store/actions.js